import { Block, Button } from '../../../../components';

interface Props {
  goNext: () => void;
  goBack: () => void;
  disabled?: boolean;
  prevText?: string;
  nextText?: string;
}

const ButtonsContainer: React.FC<Props> = ({ goBack, goNext, disabled, nextText, prevText }) => (
  <Block width="100%" display="flex" justify="space-between" pt="l">
    <Button text={prevText ?? "Volver"} onClick={goBack} variant="outlined" size="s" color="earth" />
    <Button text={nextText ?? "Continuar"} onClick={goNext} variant="outlined" size="s" color="earth" disabled={disabled} />
  </Block>
);

export default ButtonsContainer;
